module.exports = __webpack_public_path__ + "static/media/helicopter.e38bad1f.svg";